import { render, staticRenderFns } from "./NavButton.vue?vue&type=template&id=6d8df9d1&scoped=true&"
import script from "./NavButton.vue?vue&type=script&lang=js&"
export * from "./NavButton.vue?vue&type=script&lang=js&"
import style0 from "./NavButton.vue?vue&type=style&index=0&id=6d8df9d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8df9d1",
  null
  
)

export default component.exports